import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-horizontal-secondary-valve-package',
    templateUrl: './horizontal-secondary-valve-package.component.html',
    styleUrls: ['./horizontal-secondary-valve-package.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class HorizontalSecondaryValvePackageComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  secondaryValveSizeSelection!: GuruEntity;
  secondaryStrainerSelection!: GuruEntity;
  secondaryControlValveSelection!: GuruEntity;
  secondaryFlowControlSelection!: GuruEntity;
  secondaryIsolationBallValveSelection!: GuruEntity;
  secondaryIsolationSelection!: GuruEntity;
  secondaryComboSupplySelection!: GuruEntity;
  secondaryServiceFittingSelection!: GuruEntity;
  secondaryComboReturnSelection!: GuruEntity;
  secondaryNormallyOpenSelection!: GuruEntity;
  secondaryBalanceOnBypassSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.SECONDARY_VALVE_PACKAGE;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.secondaryValveSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryValveSize');
    this.secondaryStrainerSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryStrainer');
    this.secondaryControlValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryControlValve');
    this.secondaryFlowControlSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryFlowCntl');
    this.secondaryIsolationBallValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryIsolationBallValve');
    this.secondaryIsolationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryIsolation');
    this.secondaryComboSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryComboSUPValve');
    this.secondaryServiceFittingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryServcFitting');
    this.secondaryComboReturnSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecondaryComboRETValve');
    this.secondaryNormallyOpenSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USNOvalve2');
    this.secondaryBalanceOnBypassSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSecBalanceOnBypass');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
